import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import {
  bootIntercom,
  getIntercomAppId,
  loadIntercomWidget,
  updateIntercom,
} from "../utils/intercom";

export default function IntercomMessenger() {
  const appId = getIntercomAppId();
  const location = useLocation();
  const booted = useRef(false);

  useEffect(() => {
    if (!appId) {
      return;
    }

    if (!booted.current) {
      loadIntercomWidget(appId);
      bootIntercom(appId);
      booted.current = true;
      return;
    }

    // Keep Bea aware of the page the visitor is actually on. Intercom drops an update with
    // no new data (de-duped for 60s), so page-targeted bubbles would not re-evaluate.
    updateIntercom({ last_request_at: Math.floor(Date.now() / 1000) });
  }, [appId, location]);

  return null;
}
